// ===========================================
// BUSTED! BLACKJACK - CHECKOUT CANCEL PAGE
// ===========================================

import { useNavigate } from 'react-router-dom';

export function CheckoutCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="bg-gray-800 border border-gray-700 rounded-2xl p-8 max-w-md mx-4 text-center">
        {/* Cancel Icon */}
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-700 border-4 border-gray-600 flex items-center justify-center">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>

        <h2 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h2>
        <p className="text-gray-400 mb-6">
          No worries! Your purchase was cancelled and you haven't been charged.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/')}
            className="w-full py-3 bg-casino-gold-500 hover:bg-casino-gold-400 text-gray-900 font-bold rounded-xl transition-colors"
          >
            Return Home
          </button>

          <button
            onClick={() => navigate(-1)}
            className="w-full py-3 bg-gray-700 hover:bg-gray-600 text-white font-bold rounded-xl transition-colors"
          >
            Try Again
          </button>
        </div>

        <p className="text-gray-500 text-xs mt-6">
          You can purchase B-Bucks anytime from the main menu.
        </p>
      </div>
    </div>
  );
}

export default CheckoutCancelPage;
